import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';

export function isBrowser(): boolean {
  const platformId = inject(PLATFORM_ID);

  return isPlatformBrowser(platformId);
}

export function safeLocalStorageGetItem(key: string): string | null {
  if (typeof window !== 'undefined' && window.localStorage) {
    return localStorage.getItem(key);
  }

  return null;
}

export function safeLocalStorageSetItem(key: string, value: string): void {
  if (typeof window !== 'undefined' && window.localStorage) {
    localStorage.setItem(key, value);
  }
}

export function safeLocalStorageRemoveItem(key: string): void {
  if (typeof window !== 'undefined' && window.localStorage) {
    localStorage.removeItem(key);
  }
}

export function safeSessionStorageGetItem(key: string): string | null {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    return sessionStorage.getItem(key);
  }

  return null;
}

export function safeSessionStorageSetItem(key: string, value: string): void {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    sessionStorage.setItem(key, value);
  }
}

export function safeSessionStorageRemoveItem(key: string): void {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    sessionStorage.removeItem(key);
  }
}
